import './ForYou.css';
import { useParams } from 'react-router-dom';
import ribbons from '../assets/constants/ribbons.js';
import vases from '../assets/constants/vases.js';
import flowers from '../assets/constants/flowers.js';
import leafCluster from '../assets/images/leafCluster.png';
import EnvelopeNote from '../components/EnvelopeNote.js';
import ForYouFooter from '../components/ForYouFooter.js';
import React from "react";

function ForYou(props) {
    let params = useParams();
    // #TODO add checks to make sure all elements arent undefined or wrong type
    let to = params.to
    let from = params.from
    let note = params.note
    let sticker = params.sticker
    let ribbonIndex = params.ribbon
    let displayIndex = params.display

    let flowersArray = params.flowers.split(",")

    return (
        <div className="">
            <div className="">
                    <div className="forYouFlowers">
                        <img className="leafClusterImage" src={leafCluster} alt="green leaf cluster"/>
                        {flowersArray.map((flower, index) => (
                            <img key={index} className={"flowerForYouImageLarge flowerForYouImageLarge" + index} src={flowers[parseInt(flower)].img} alt={flowers[parseInt(flower)].name} />
                        ))}
                    </div>
                    <img className="selectedVaseForYou" src={vases[displayIndex].src} alt={vases[displayIndex].alt} />
                    <img className="selectedVaseForYou backSelectedVaseForYou" src={vases[displayIndex].backSrc} alt={vases[displayIndex].alt} />
                    <div className={"ribbonOnVaseForYou ribbonOnVaseForYou" + ribbons[ribbonIndex].type}>
                        <img className="chosenRibbonForYou outlineRibbonChosenForYou" src={ribbons[ribbonIndex].outlineSrc} alt="outline of a bow" />
                        <img className="chosenRibbonForYou" src={ribbons[ribbonIndex].src} alt={ribbons[ribbonIndex].alt} />
                    </div>
                </div>
                <EnvelopeNote to={to} from={from} note={note} sticker={sticker}/>
                <ForYouFooter />
        </div>

    )

}

export default ForYou;